<h1 class="title" translate>HOMEPAGE.RENEW.TITLE</h1>

<app-page-wrapper>
  <div class="desc-wrapper">
    <img class="success-icon" src="assets/images/success-icon.svg" />
    <div
      class="desc"
      [innerHTML]="
        'RENEW_PAGE.SUCCESS_STEP.TITLE'
          | translate
            : {
                certType: certType | translate,
              }
      "></div>
  </div>

  <div class="ic1-my-12">
    <ng-ui-kit-toast
      *ngIf="showInfo && automatic === false"
      class="renew-success-toast"
      [hideClose]="true"
      status="info"
      [text]="'RENEW_PAGE.SUCCESS_STEP.DOWNLOAD_GOSIGN' | translate">
    </ng-ui-kit-toast>
  </div>

  <div class="ic1-my-12">
    <ng-ui-kit-toast
      *ngIf="automatic"
      class="renew-success-toast"
      [hideClose]="true"
      style="cursor: pointer"
      status="info"
      [text]="'RENEW_PAGE.SUCCESS_STEP.FA_ACTIVATE' | translate"
      (click)="goToActivatePage()">
    </ng-ui-kit-toast>
  </div>

  <div class="box-wrapper">
    <div class="box-content">
      <img
        src="https://assets.infocert.it/logos/products/my-infocert/favicon/96x96.png"
        class="instruction-icon" />
      <div class="box-text">
        <div class="box-desc" translate>RENEW_PAGE.SUCCESS_STEP.BOX_DESC</div>
        <div
          class="instruction-text"
          [innerHTML]="
            'RENEW_PAGE.SUCCESS_STEP.DOWNLOAD_MYINFOCERT' | translate
          "></div>
      </div>
    </div>
    <div class="homepage-button">
      <ng-ui-kit-button
        color="tertiary"
        [label]="'RENEW_PAGE.SUCCESS_STEP.BACK_TO_HOMEPAGE' | translate"
        type="button"
        size="sm"
        (onClick)="goToHomepage()">
      </ng-ui-kit-button>
    </div>
  </div>
</app-page-wrapper>
